import LegalPage from "@/components/LegalPage";

const Disclaimer = () => (
  <LegalPage
    seoTitle="Disclaimer | Evaya Ventures"
    seoDescription="Disclaimer for the Evaya Ventures website."
    path="/disclaimer"
    title="Disclaimer"
    intro="Please read this disclaimer carefully before using the Evaya Ventures website."
    testId="disclaimer-page"
    sections={[
      {
        heading: "General Information Only",
        body: [
          "The content of this website is provided for general informational purposes. It does not constitute an offer, advertisement, recommendation or solicitation of any kind, and should not be relied upon for making any investment or purchase decision.",
        ],
      },
      {
        heading: "Imagery and Visuals",
        body: [
          "Images used on this website are representative and indicative in nature. They are intended to convey the company's focus areas and design sensibility, and do not depict completed projects of Evaya Ventures unless expressly stated.",
        ],
      },
      {
        heading: "Forward-Looking Statements",
        body: [
          "Statements on this website regarding future developments, opportunities or plans are forward-looking and subject to change. Evaya Ventures is an emerging company at the beginning of its development journey, and details of any future development will be announced only as they are formalised.",
        ],
      },
      {
        heading: "Regulatory Compliance",
        body: [
          "Any future real-estate project undertaken by Evaya Ventures will be developed and marketed in compliance with applicable laws and regulations, including registration under applicable real-estate regulatory authorities wherever required. Project-specific registration details will be published with each project announcement.",
        ],
      },
      {
        heading: "External Links",
        body: [
          "This website may contain links to external websites. Evaya Ventures is not responsible for the content or practices of any external site.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any questions regarding this disclaimer, please contact us at [official email].",
        ],
      },
    ]}
  />
);

export default Disclaimer;
